import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';

import { DisabledFeatures } from '@project_app/config/feature.config';
import { DeviceService } from '@core/services/util/device.service';

@Directive({
    selector: '[appFeatureToggle]',
    standalone: true
})
export class FeatureToggleDirective implements OnInit {
    @Input() appFeatureToggle: string;

    device: string;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private deviceService: DeviceService
    ) {
        this.device = this.deviceService.getDevice();
    }

    ngOnInit() {
        if (this.isEnabled()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    isEnabled() {
        const { features } = DisabledFeatures;

        if (features[this.device].hasOwnProperty(this.appFeatureToggle)) {
            return features[this.device][this.appFeatureToggle];
        }

        return true;
    }
}
